//saves requests to server. Only updates the DB when user stops typing for a while
export default function debounce(a, b, c) {
	var d, e;
	return function() {
		function h() {
			d = null;
			c || (e = a.apply(f, g));
		}
		var f = this,
			g = arguments;
		return clearTimeout(d), (d = setTimeout(h, b)), c && !d && (e = a.apply(f, g)), e;
	};
}

//to save html as a string. We dont want to show HTML in the sidebar
//react quill stores it as html
export function removeHTMLTags(str) {
	return str.replace(/<[^>]*>?/gm, '');
}
